<template>
    <div>
        <MultiSelect
            v-model="selectedUsers"
            :options="users"
            filter
            :maxSelectedLabels="2"
            display="chip"
            optionLabel="fullname"
            optionValue="id"
            placeholder="Select users"
            class="w-full md:w-14rem"
            :class="{ 'p-invalid': props.isInvalid }"
            @change="emit('update:modelValue', selectedUsers)"
        />
    </div>
</template>

<script setup>
import { ref, onMounted, defineProps, defineEmits, computed, watch } from 'vue';
import useUserComposable from '../../../composables/UserComposable';

const { users, getAllUsers } = useUserComposable();

const emit = defineEmits(['update:modelValue']);

// props
const props = defineProps({
    modelValue: {
        type: Array,
    },
    isInvalid: {
        type: Boolean,
    },
});

// states
const selectedUsers = ref([]);

// computed properties
const propsModelValue = computed(() => {
    return props.modelValue;
});

// on load
onMounted(() => {
    // load all users
    loadAllUsers();
    // load current selected user if exists
    if (propsModelValue.value && propsModelValue.value.length > 0) {
        loadExistingUsers();
    }
});

// watchers
watch(propsModelValue, () => {
    loadExistingUsers();
});

const loadAllUsers = async () => {
    await getAllUsers();
};

const loadExistingUsers = () => {
    selectedUsers.value = propsModelValue.value;
};
</script>
